/* eslint-disable */
import { authHeader, regHeader, bidHeader } from "../helpers";
import { axiosService } from "./axios.service";

export const userService = {
  login,
  logout,
  register,
  forgot,
  confirm,
  submitbid,
  confirmbid,
  changePassword,
  callMe,
  contact,
  getById,
  getProperty,
  delete: _delete
};

let deleteCookie = name => {
    document.cookie = `${name}=; Domain=${window.location.hostname}; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
    //window.$cookies.remove(`${name}`);
};

const validStatuses = [200, 201, 202, 203, 204, 300, 301, 302, 303, 304];

function login(username, password) {
  return axiosService
    .post("login", {
      username,
      password
    })
    .then(handleResponse)
    .then(user => {
      if (user.data) {
        // store user details and token in local storage to keep user logged in between page refreshes
        localStorage.setItem("user", JSON.stringify(user.data.token));
      }
      return user;
    });
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem("user");
  deleteCookie("SESSION");
}

function register(user) {
  let url = "register";
  if(user.code) {
    url = "registerwithcode"
  }

  return axiosService
    .register(url, regHeader(user))
    .then(handleResponse);
}

function forgot(user) {
  return axiosService
    .post("forgot-password", {
      "username": user
    })
    .then(handleResponse);
}

function callMe(phonenumber) {
  return axiosService.post("call-me", {
    "phone": phonenumber
  })
  .then(handleResponse)
  .then(response => {
    return response;
  });
}

function getProperty(code) {
  return axiosService.get(`/property/bycode?code=${code}`)
  .then(handleResponse)
  .then(response => {
    return response;
  });
}

function contact(message) {
  return axiosService.post("contact", {
    "message": message
  })
  .then(handleResponse)
  .then(response => {
    return response;
  });
}

function changePassword(password, changeToken) {
  return axiosService
    .post("change-password", {
      "token": changeToken,
      "password": password
    })
    .then(handleResponse)
    .then(user => {
      // login successful if there's a token in the response
      if (user.data) {
        // store user details and token in local storage to keep user logged in between page refreshes
        localStorage.setItem("user", JSON.stringify(user.data.token));
      }

      return user;
    });
}

function confirm(user) {
  const requestOptions = {
    token: user
  };
  return axiosService
    .post("confirm", requestOptions)
    .then(handleResponse)
    .then(user => {
      // login successful if there's a token in the response
      if (user.data) {
        // store user details and token in local storage to keep user logged in between page refreshes
        localStorage.setItem("user", JSON.stringify(user.data.token));
      }

      return user;
    });
}

function submitbid(bid) {
  return axiosService.post("bid/submit", bidHeader(bid))
  .then(handleResponse)
  .then(response => {
    return response;
  });
}

function confirmbid(user) {
  const requestOptions = {
    token: user
  };
  return axiosService
    .post("bid/confirm", requestOptions)
    .then(handleResponse)
    .then(user => {
      // login successful if there's a token in the response
      if (user.data) {
        // store user details and token in local storage to keep user logged in between page refreshes
        localStorage.setItem("user", JSON.stringify(user.data.token));
      }
      return user;
    });
}

function getById(id) {
  return axiosService.get("property/current").then(handleResponse);
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader()
  };

  return fetch(`${config.apiUrl}/users/${id}`, requestOptions).then(
    handleResponse
  );
}

function handleResponse(response) {
  if (validStatuses.includes(response.status)) {
    return response;
  }
  if (!response.data) {
    if (response.status === 401) {
      // auto logout if 401 response returned from api
      logout();
      location.reload(true);
    }

    const error = (data && data.message) || response.statusText;
    return Promise.reject(error);
  }
}
